import React from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { Stack } from "@mui/material"
import {
  AUTHENTICATED_ENTRY,
  PROFESSOR_AUTHENTICATED_ENTRY,
} from "configs/AppConfig"
import { useAuthContext } from "contexts/AuthContext"
import ContainerWrapper from "components/UI/ContainerWrapper"
import Header from "components/Auth/Header/Header"
import { USER_TYPES, STAFF_TYPES } from "common/constants"

const PublicRoutes = () => {
  const { userData, isConfigurationCompleted } = useAuthContext()
  const location = useLocation()

  const isCreateAccount = location.pathname === "/create-account"
  const hasQrToken = new URLSearchParams(location.search).has("qrToken")

  if (
    STAFF_TYPES.includes(userData?.userTypeId) &&
    !isCreateAccount &&
    !hasQrToken
  ) {
    return <Navigate to="/staff" replace />
  }
  // Professors have their own portal — send them there instead of to missions.
  if (
    userData?.userTypeId === USER_TYPES.TEACHER &&
    !isCreateAccount &&
    !hasQrToken
  ) {
    return <Navigate to={PROFESSOR_AUTHENTICATED_ENTRY} replace />
  }
  return userData !== null &&
    userData?.userId > 0 &&
    !isCreateAccount &&
    !hasQrToken ? (
    <Navigate
      to={
        isConfigurationCompleted
          ? AUTHENTICATED_ENTRY
          : "/account?firstSetup=1&welcomeMessage=1"
      }
    />
  ) : (
    <Stack sx={{ minHeight: "100dvh" }}>
      <ContainerWrapper>
        <Header />
        <Outlet />
      </ContainerWrapper>
    </Stack>
  )
}

export default PublicRoutes
